export default {
      id: "flex-alignContent-flex-end-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignContent-flex-end-usage",
      toString: function () {
        return this.url;
      }
    }